import { useRef, useEffect, useState } from "react";
import { DefaultHeading } from "../ScreenHeading";
import Header from "../Header";
import CustomButton from "../CustomButton";
import NoticeCard from "../NoticeCard";
import RequiredDocumentListCard from "../RequiredDocumentListCard";
import { InfoOutlinedCircle, Close } from "../../assets/svgs";
import { logAnalyticEvent } from "../../analytics";
import { EVENT_NAME, PAGE } from "../../constants";
import "./styles.scss";
import { convertTimestamp } from "../../utils";

// Static Component
const DocumentListModal = ({
  visible,
  documents = [],
  onClickClose,
  hideToolTip,
}) => {
  const contentRef = useRef(null);
  const [startTime, setStartTime] = useState(0);

  useEffect(() => {
    if (visible && contentRef.current) {
      contentRef.current.scrollTop = 0;
    }
    setStartTime(Date.now());
    return () => {
      if (visible) {
        const endTime = Date.now();
        logAnalyticEvent(EVENT_NAME.PAGE_VIEW, {
          page_title: PAGE.REQUIRED_DOCUMENT,
          path: `${window.location.origin}/${PAGE.REQUIRED_DOCUMENT}`,
          end_time: endTime,
          start_time: startTime,
          time_spent: convertTimestamp(endTime - startTime),
        });
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  return (
    <div className={`document-list-modal ${visible ? "show" : "hide"}`}>
      <div className="document-list-modal-content" ref={contentRef}>
        <Header
          containerStyle={"d-flex justify-content-end w-100"}
          rightIcon={Close}
          onClickRightIcon={onClickClose}
          rightIconStyle={{
            width: "1.25rem",
            height: "1.25rem",
            marginRight: "1.5rem",
            cursor: "pointer",
          }}
        />
        <DefaultHeading
          heading={"required_document"}
          description={"required_document_description"}
          style={{ headingFontSize: 32, descriptionFontSize: 16 }}
        />
        <RequiredDocumentListCard
          documentList={documents}
          hideToolTip={hideToolTip}
        />
        <NoticeCard
          backgroundColor={"success-50"}
          icon={InfoOutlinedCircle}
          headingText={"company-details.why_document_needed"}
          descriptionText={"company-details.why_document_needed_description"}
        />
        <CustomButton buttonText={"got_it"} onClick={onClickClose} />
      </div>
    </div>
  );
};

export default DocumentListModal;
